<template>
  <el-dialog
    title="营销素材"
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :before-close="handleClose"
    :close-on-click-modal="false"
    class="dialog"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
      <el-tab-pane :name="item.type" v-for="item in list" :key="item.type">
        <span slot="label"><i class="ficon " :class="renderIcon(item.type)"></i> {{ item.type_label }}</span>
        <div class="tab-content">
          <template v-if="item.type == 1">
            <template v-for="(material,ind) in item.list" >
              <h4 class="date">{{ material.update_time }}</h4>
              <div class="rich-text" v-html="material.content.name"></div>
              <div class="py-4">
                <el-button
                  class="copy"
                  size="small"
                  type="primary"
                  plain
                  v-clipboard="() => material.content.name"
                  v-clipboard:success="handleCopySuccess"
                  v-clipboard:error="handleCopyError"
                >复制文案</el-button>
              </div>
              <div class="poster-imgs">
                <div class="poster-box" v-for="(poster,index) in material.content.url" :key="poster">
                  <el-image :ref="'poster'+ind + index" :src="poster" fit="cover" class="poster" :preview-src-list="material.content.url"/>
                  <div class="action">
                    <span @click="downloadByBlob(poster,`产品海报${index+1}`)"><i class="ficon ficon-xiazai2"></i>下载</span>
                    <span @click="previewImg(ind,index)"><i class="ficon ficon-chakan-copy"></i>查看</span>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else-if="item.type == 2">
            <template v-for="material in item.list" >
              <h4 class="date">{{ material.update_time }}</h4>
              <div class="photos">
                <div class="photos-inner" v-for="photo in material.content" :key="photo.url">
                  <div class="photos-box">
                    <el-image :src="photo.url" fit="cover" class="w-full h-full" @click="seePhoto(photo.url,item.list)"/>
                    <div class="action">
                      <span @click="downloadByBlob(photo.url,photo.name)"><i class="ficon ficon-xiazai2"></i>下载</span>
                      <span @click="seePhoto(photo.url,item.list)"><i class="ficon ficon-chakan-copy"></i>查看</span>
                    </div>
                  </div>
                  <p class="name">{{ photo.name }}</p>
                </div>
              </div>
            </template>
          </template>
          <template v-else-if="item.type == 3">
            <div class="video-box" v-for="video in item.list" :key="video.update_time">
              <h4 class="date">{{ video.update_time }}</h4>
              <div class="video_player">
                <Player
                  theme="dark"
                >
                  <Video
                    crossOrigin
                  >
                    <source 
                      :data-src="video.content[0]?.url" 
                      type="video/mp4"
                    />
                  </Video>
                  <Ui>
                    <Controls>
                      <ControlGroup>
                        <ScrubberControl />
                      </ControlGroup>
                      <PlaybackControl/>
                      <VolumeControl />
                      <TimeProgress separator="/" class="pt-1"/>
                      <ControlSpacer />
                      <FullscreenControl />
                    </Controls>
                  </Ui>
                </Player>
              </div>
              <p class="video-name">{{ video.content[0]?.name }}</p>
              <el-button class="copy" size="small" type="primary" plain @click="downVideo(video.content[0]?.url,video.content[0]?.name)">下载</el-button>
            </div>
          </template>
          <template v-else-if="item.type == 4">
            <div class="file-box" v-for="file in item.list" :key="file.update_time">
              <h4 class="date">{{ file.update_time }}</h4>
              <div class="file" v-for="f in file.content" :key="f.url">
                <img v-if="f.file_type === 'pdf'" src="@/assets/img/icons/pdf-icon.png" class="file-icon"/>
                <img v-else-if="f.file_type === 'excel'" src="@/assets/img/icons/excel-icon.png" class="file-icon"/>
                <img v-else-if="f.file_type === 'ppt'" src="@/assets/img/icons/ppt-icon.png" class="file-icon"/>
                <img v-else-if="f.file_type === 'word'" src="@/assets/img/icons/word-icon.png" class="file-icon"/>
                <p class="file-name">{{ f.file_name }}</p>
                <el-button type="primary" plain class="copy !w-20" @click=downloadFile(f.url,f.file_name)>下载</el-button>
              </div>
            </div>
          </template>
        </div>
      </el-tab-pane>
    </el-tabs>
    <productMaterialPhotoPreview ref="photoPreview"></productMaterialPhotoPreview>
  </el-dialog>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import clipboard from "@/directives/clipboard";
import { downloadByBlob,downloadVideo } from "@/utils/file-download.js";
import productMaterialPhotoPreview from './product-material-photo-preview.vue';
import { getMaterial } from '~/services/product'
import { Player, Video,  Ui, Controls,FullscreenControl,PlaybackControl,ScrubberControl,ControlGroup,TimeProgress,ControlSpacer,VolumeControl,} from '@vime/vue';

import {
  REQUEST_CODES,
} from "@/constants/const-http";

export default defineComponent({
    data() {
      return {
        activeName: '',
        dialogVisible:false,
        list:[]
      };
    },
    directives: { clipboard },
    components:{
      productMaterialPhotoPreview,
      Player,
      Video,
      Ui, Controls,FullscreenControl,PlaybackControl,ScrubberControl,ControlGroup,
      TimeProgress,ControlSpacer,VolumeControl,
    },
    methods:{
      downloadByBlob,
      downVideo(url,name){
        const that = this
        this.$message.info('开始下载')
        downloadVideo(url,name,function(){
          that.$message.success("下载成功");
        })
      },
      previewImg(ind,index){
        const poster = this.$refs['poster' + ind + index];
        poster[0].clickHandler()
      },
      handleClose() {
        this.dialogVisible = false
      },
      handleClick(tab, event) {
        console.log(tab.index);
      },
      handleCopySuccess() {
        this.$message.success("复制成功");
      },
      handleCopyError() {
        this.$message.error("复制失败");
      },
      seePhoto(imgPath,photos){
        let imgs = []
        for(let i=0;i<photos.length;i++){
          imgs = imgs.concat(photos[i].content)
        }
        console.log(imgs)
        this.$refs.photoPreview.setData(imgPath,imgs)
      },
      downloadFile(url, name) {
        const x = new XMLHttpRequest();
        x.open("GET", url, true);
        x.responseType = 'blob';
        x.onload = function (e) {
          const url = window.URL.createObjectURL(x.response)
          const a = document.createElement('a');
            a.href = url
            a.download = name ;
            a.click()
            a.remove();
        }
        x.send();
      },
      setData(product_no){
        this.dialogVisible = true
        getMaterial(product_no).then(res=>{
          console.log('res',res)
          if (res.code !== REQUEST_CODES.ERROR_OK) {
            throw new Error(msg);
          }
          this.list = res.data
          this.activeName = res.data[0].type
        })
      },
      renderIcon(type){
        switch (type) {
          case '1':
            return 'ficon-huokehaibao'
          case '2':
            return 'ficon-tupian1'
          case '3':
            return 'ficon-shipin2'
          case '4':
            return 'ficon-wj-czwj'
        }
      }
    },
    computed:{
      dialogWidth(){
        if(this.activeName === '2'){
          return '620px'
        }
        return "576px"
      }
    }
  })
</script>

<style lang="scss" scoped>
.dialog ::v-deep .el-dialog__title {
  font-size: 20px;
  padding-left: 8px;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.dialog ::v-deep .el-dialog__body {
  padding: 5px 28px 28px 28px;
}
.tabs ::v-deep .el-tabs__header {
  margin-bottom: 20px;
}
.tabs ::v-deep .el-tabs__item {
  font-size: 18px;
  --tw-text-opacity: 1;
  color: rgba(96, 99, 112, var(--tw-text-opacity));
}
.tabs ::v-deep .el-tabs__active-bar {
  background-color: $color-black-2;
}
.tabs ::v-deep .el-tabs__item.is-active {
  color: $color-black-2;
}
.tabs ::v-deep .el-tabs__nav-wrap:after {
  background-color: #E5E7EB;
}
.tab-content {
  max-height: 538px;
  overflow-y: auto;
  overflow-x: hidden;
}
.tab-content .date {
  color: $color-grey-15;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
}
.tab-content .copy {
  width: 112px;
  height: 36px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  border-color: $color-orange;
}
.rich-text {
  white-space: pre-line;
  font-size: 12px;
  line-height: 1.5;
  color: #3d3d3d;
}
.poster-imgs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -0.75rem;
}
.poster-imgs .poster-box {
  height: 11.25rem;
  margin-right: 0.75rem;
  margin-bottom: 0.75rem;
  overflow: hidden;
  position: relative;
  width: 7.5rem;
  border-radius: 4px;
}
.poster-imgs .poster-box:hover .action {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.poster-imgs .poster-box .poster {
  height: 100%;
  width: 100%;
}
.poster-imgs .poster-box .action {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  display: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  position: absolute;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(0,0,0,.6);
  height: 36px;
}
.poster-imgs .poster-box .action span {
  cursor: pointer;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  position: relative;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  font-size: 12px;
}
.poster-imgs .poster-box .action span .ficon {
  margin-right: 0.25rem;
}
.poster-imgs .poster-box .action span:first-child::after {
  content: '';
  display: block;
  position: absolute;
  width: 1px;
  height: 14px;
  background-color: #fff;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.photos {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -0.75rem;
  margin-bottom: 1rem;
}
.photos-inner {
  margin-right: 0.75rem;
  margin-bottom: 0.75rem;
  width: 180px;
}
.photos-inner:hover .action {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.photos-inner .name {
  padding-top: 0.75rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  color: $color-grey-15;
  font-size: 15px;
}
.photos-box {
  height: 7.5rem;
  overflow: hidden;
  position: relative;
  width: 100%;
  border-radius: 4px;
}
.photos-box .action {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  display: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  position: absolute;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(0,0,0,.6);
  height: 36px;
}
.photos-box .action span {
  cursor: pointer;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  position: relative;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  font-size: 12px;
}
.photos-box .action span .ficon {
  margin-right: 0.25rem;
}
.photos-box .action span:first-child::after {
  content: '';
  display: block;
  position: absolute;
  width: 1px;
  height: 14px;
  background-color: #fff;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.video-box {
  margin-bottom: 28px;
}
.video-box .video_player {
  width: 350px;
  margin-bottom: 12px;
}
.video-box .video-name {
  font-size: 15px;
  color: $color-grey-15;
  margin-bottom: 10px;
}
.file-box {
  margin-bottom: 20px;
}
.file {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  position: relative;
  padding: 10px 0;
}
.file-icon {
  width: 32px;
  height: 36px;
}
.file-name {
  font-size: 14px;
  flex: 1;
  color: $color-grey-15;
  padding-right: 36px;
  padding-left: 8px;
}
.file-name:after {
  display: block;
  content: '';
  position: absolute;
  left: 40px;
  right: 6px;
  bottom: 0;
  border-bottom: 1px solid #F2F2F2;
}
</style>